import { observable, action } from 'mobx';

export class IdDetailDialog {
  // effect
  @observable showIdDialogInfo = {}
  @action changeIdDialogInfo = (obj) => {
    this.showIdDialogInfo = obj;
  }
}

export default new IdDetailDialog();
